import { render, staticRenderFns } from "./GalleryModal.vue?vue&type=template&id=636ed31c&scoped=true"
import script from "./GalleryModal.vue?vue&type=script&lang=js"
export * from "./GalleryModal.vue?vue&type=script&lang=js"
import style0 from "./GalleryModal.vue?vue&type=style&index=0&id=636ed31c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636ed31c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636ed31c')) {
      api.createRecord('636ed31c', component.options)
    } else {
      api.reload('636ed31c', component.options)
    }
    module.hot.accept("./GalleryModal.vue?vue&type=template&id=636ed31c&scoped=true", function () {
      api.rerender('636ed31c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/trial/components/GalleryModal.vue"
export default component.exports